<template>
  <main class="text-center ">
    <h5 class="m-3">Export Options</h5>
    <p>Exporting to the old inventory.</p>
    <button class="btn btn-primary" v-on:click.prevent="start">Start</button>
  </main>
</template>

<script>
export default {
	name: 'ExportOptions',
	methods: {
		start: function() {
			if (!confirm('Please confirm script start.')) return;

			this.$notify({
				group: 'main',
				title: 'Started.',
				text: 'Exporting to the old inventory.',
				type: 'success',
			});

			this.$axios.post(`/script`, {script: 'sync'})
				.then((response) => {
					// console.log(response.data.data);
				})
				.catch((error) => {
					console.log(error);
					this.$notify({
						group: 'main',
						title: 'Error.',
						text: 'The export has failed.',
						type: 'warn',
					});
				})
				.finally(()=>{
					//
				});
		},
	},
};
</script>
